import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Cpu, FileWarning, Scale } from 'lucide-react';
export function RevelationSection() {
  const points = [{
    icon: <Building2 className="w-6 h-6 text-electric-blue" data-id="element-206" />,
    title: 'They Are Private Companies',
    desc: 'Experian, Equifax, and TransUnion are not government agencies. They make money by selling YOUR debt data.'
  }, {
    icon: <Cpu className="w-6 h-6 text-electric-blue" data-id="element-207" />,
    title: 'Advanced AI Filters',
    desc: 'In 2026, they use AI so advanced it detects any generic dispute letter in microseconds and flags it.'
  }, {
    icon: <FileWarning className="w-6 h-6 text-electric-blue" data-id="element-208" />,
    title: "Why You're Failing",
    desc: "You aren't 'irresponsible.' You're sending letters that the bank's AI already knows how to block."
  }, {
    icon: <Scale className="w-6 h-6 text-gold" data-id="element-209" />,
    title: 'The Legal Loophole',
    desc: 'The solution is Metro 2 Compliance Architecture. Speak to the algorithm in its own legal language to force deletions by law.'
  }];
  return <section className="py-24 px-4 bg-[#050508] relative border-y border-electric-blue/20 overflow-hidden" data-id="element-210">
      {/* Matrix-like background effect */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231E90FF' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
    }} data-id="element-211"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-214">
            The <span className="text-electric-blue" data-id="element-215">Algorithm</span> Revelation
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-216">
            I discovered the truth about how the credit system actually works
            behind closed doors.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-217">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`p-6 rounded-xl border ${index === 3 ? 'bg-gold/5 border-gold/30' : 'bg-[#0a0a0f] border-white/10'} hover:border-electric-blue/50 transition-colors`} data-id="element-218">
              <div className="flex items-start gap-4" data-id="element-219">
                <div className={`p-3 rounded-lg ${index === 3 ? 'bg-gold/10' : 'bg-electric-blue/10'}`} data-id="element-220">
                  {point.icon}
                </div>
                <div data-id="element-221">
                  <h3 className={`text-xl font-bold mb-2 ${index === 3 ? 'text-gold' : 'text-white'}`} data-id="element-222">
                    {point.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-223">{point.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}